// Constants for image validation
export const VALID_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
];

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB

// Helper function to convert data URL to File.
// Uses atob instead of fetch() — fetch(dataUrl) is unreliable on Android WebView.
export function dataUrlToFile(dataUrl: string, basename: string): File {
  const [header, base64] = dataUrl.split(',');

  const mimeMatch = header.match(/:(.*?);/);
  const mimeType = mimeMatch ? mimeMatch[1] : 'image/jpeg';

  const extensionMap: Record<string, string> = {
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
  };
  const extension = extensionMap[mimeType] ?? 'jpg';
  const normalizedMime = extensionMap[mimeType] ? mimeType : 'image/jpeg';

  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], `${basename}.${extension}`, { type: normalizedMime });
}

// Validate image file type and size
export function validateImageFile(file: File): void {
  if (!VALID_IMAGE_TYPES.includes(file.type)) {
    throw new Error(
      'Invalid file type. Please select a JPEG, PNG, WebP, or GIF image.'
    );
  }

  if (file.size > MAX_IMAGE_SIZE) {
    throw new Error('File too large. Please select an image smaller than 10MB.');
  }
}
